import React from 'react';
import style from './style.scss';

class NewOrder extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className='the-news-wrap-item'>
        <section className="new-order">
          <h2 className='new-order-title'>Đơn hàng mới</h2>
          <div className='new-order-sum-item'>
            <span className='vtd-product item-sum-icon'></span>
            <span className='wtap-item-sum'>
              <span className='item-title'>25 đơn hàng</span>
              <span className='item-desc'>doanh số tháng này</span>
            </span>
          </div>
          <div className='wrap-item-desc'>
            <div className='new-order-item-desc'>
              <span className='item-desc-icon item-three-dot'></span>
              <span className='wtap-item-desc'>
                <span className='item-title'>25 đơn hàng</span>
                <span className='item-desc'>Đang chờ xử lý</span>
              </span>
            </div>

            <div className='new-order-item-desc'>
              <span className='item-one-line item-desc-icon'></span>
              <span className='wtap-item-desc'>
                <span className='item-title'>25 đơn hàng</span>
                <span className='item-desc'>Đang tạm dừng</span>
              </span>
            </div>

            <div className='new-order-item-desc'>
              <span className='vtd-chu-y item-desc-icon'></span>
              <span className='wtap-item-desc'>
                <span className='item-title'>25 đơn hàng</span>
                <span className='item-desc'>Sắp xếp hàng</span>
              </span>
            </div>

            <div className='new-order-item-desc'>
              <span className='vtd-close item-desc-icon'></span>
              <span className='wtap-item-desc'>
                <span className='item-title'>25 đơn hàng</span>
                <span className='item-desc'>Xếp hàng</span>
              </span>
            </div>
          </div>
          <p className='new-order-view-all'> <a href='' className='view-all-link'>Xem tất cả</a></p>
        </section>
      </div>
    );
  }
}

export default NewOrder;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/new-order/NewOrder.jsx